import apiSportsObjects from '@/api/sports-objects'

const state = {
  isLoading: false,
  sportsObjects: [],
  validationErrors: null,
  isSubmitting: false,
}

export const mutationTypes = {
  getSportObjectsSearchStart: '[sportsObjects search] getSportObjectsStart',
  getSportObjectsSearchSuccess: '[sportsObjects search] getSportObjectsSuccess',
  getSportObjectsSearchFailure: '[sportsObjects search] getSportObjectsFailure',
}

export const actionType = {
  getSportSearchObjects: '[sportsObjects search] getSportObjects',
}

const mutations = {
  [mutationTypes.getSportObjectsSearchStart](state) {
    state.isLoading = true
    state.validationErrors = null
    state.sportsObjects = []
  },

  [mutationTypes.getSportObjectsSearchSuccess](state, payload) {
    state.sportsObjects = payload
    state.isLoading = false
  },

  [mutationTypes.getSportObjectsSearchFailure](state, payload) {
    state.validationErrors = payload
    state.isLoading = false
  },
}

const actions = {
  [actionType.getSportSearchObjects](context, params) {
    context.commit(mutationTypes.getSportObjectsSearchStart)
    return new Promise((resolve) => {
      apiSportsObjects
        .getSportSearchObjects(params)
        .then((response) => {
          context.commit(
            mutationTypes.getSportObjectsSearchSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.getSportObjectsSearchFailure,
            result.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
